import { createV3Queries } from "@query/utils/createV3Queries";
import { biometricIdentityVerificationRequestsApi } from "@api";

/**
 * Biometric identity-verification **request** registry — mirrors
 * `BiometricIdentityVerificationRequestsApi` 1:1
 * (`/v3/compliance/biometric-identity-verification-requests`).
 *
 * This is the resource a `BiometricIdentityVerification` requirement's
 * `dataSourceId` names — the payer↔payee ask. The verification itself is
 * reachable only by the payee, and reaches the payer as the request's
 * `biometricIdentityVerification` embed once the request is terminal.
 */
export const queriesBiometricIdentityVerificationRequests = createV3Queries(
  "biometricIdentityVerificationRequestsApi",
  biometricIdentityVerificationRequestsApi
);
